import barChartTemplate from './barChartWidget.html';

import { WidgetController } from './../widget';
import { balanceHistory } from '../../../services/arsweb/RoutingPaths';
import { ChartUtil } from '../../../utils/chart/ChartUtil';
import { keyLanguage } from 'fides-angularjs-components/src/fts-services/fts-user-service';
import { CONSOLIDATION_CURRENCY_PARAMS } from "../../../controller/CommonViewController";

export function barChart() {
    return {
        restrict: 'E',
        scope: {
            controller: '=',
            consolitationcurrency: '=',
            selDay: '='
        },
        transclude: 'true',
        templateUrl: barChartTemplate,
        controller: BarChartController,
        controllerAs: 'barChartController'
    };
}

export class BarChartController extends WidgetController {
    constructor($scope, userService, arsMainDependencies) {

        super($scope, userService, arsMainDependencies, 'WIDGET_BAR_CHART', 'mdi-action-assessment', 'barChartWgtKey');

        this.filterFormatter = userService.filterFormatter;

        // Listen to consolidation currency selection change
        $scope.$on('consolidationCurrency.change', () => this.loadWidgetContent());

        // Listen to day selection change
        $scope.$on('selDay.change', () => this.loadWidgetContent());
    }

    loadWidgetContent() {
        if (this.$scope.controller) {
            this.userService.promise.then(() => {
                this.loadBalanceContent(this.$scope.controller.$scope.selDay, this.$scope.controller.$scope.consolitationcurrency);
            });
        }
    }

    loadBalanceContent(day, curr) {
        this.noData = false;
        this.balanceDataset = [];
        // selection of consolidation curr for backend call
        this.accountService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = curr.code;
        this.accountService.service.config.params['days'] = day;
        const locale = this.store.get(keyLanguage);


        this.barChartOptions = ChartUtil.getBarChartOptions(this.filterFormatter);
        this.barChartOptions.xaxis.font.color = 'black';
        this.barChartOptions.yaxis.font.color = 'black';
        this.balanceHistoryMonths = ChartUtil.getBalanceMonthTitle(day, locale);

        this.chartPromise = this.accountService.getUserSummaryData(balanceHistory).then((data) => {
            if (data.length > 0) {
                this.barChartOptions.series.fractionDigits = data[0].fractionDigits;
                ChartUtil.formatAxisDisplay(day, this.barChartOptions, [1, "day"], '%d', locale);

                const positive = [];
                const negative = [];
                data.forEach((it) => {
                    if (it.closingBalance >= 0) {
                        positive.push([new Date(it.date), it.closingBalance]);
                    } else {
                        negative.push([new Date(it.date), it.closingBalance]);
                    }
                });
                this.balanceDataset = [{data: positive}, {data: negative}];
            } else {
                this.noData = true;
            }
        });

    }
}
